import { Component, OnInit, Input } from '@angular/core';
import { EmitterService } from 'core/services/emitter.service';
import { JobsService } from 'core/services/jobs.service';
import { MarsQuestionsListService } from './services/mars-questions-list.service';
import { MarsQuestionsStatsService } from './services/mars-questions-stats.service';

@Component({
  selector: 'lms-mars-questions',
  templateUrl: './mars-questions.component.html',
  styleUrls: ['./mars-questions.component.scss'],
  providers: [MarsQuestionsListService, MarsQuestionsStatsService]
})
export class MarsQuestionsComponent implements OnInit {
  @Input() listId: string;
  @Input() group: any;

  public viewModes = {
    questions: 'questions',
    create: 'create',
    edit: 'edit'
  };
  public view = this.viewModes.questions;

  public toolbarConfig: any;
  public dataSource: any;
  public stats: any = {};
  public selectedQuestion: any;

  constructor(
    public marsQuestionsListService: MarsQuestionsListService,
    private marsQuestionsStatsService: MarsQuestionsStatsService,
    private jobsService: JobsService
  ) {}

  async ngOnInit() {
    const options = {
      filters: {
        groupId: this.group.id
      }
    };
    this.dataSource = await this.marsQuestionsListService.getDatasource(this.listId, options);

    this.toolbarConfig = {
      list: {
        listId: this.listId,
        columnChooser: false,
        download: false,
        filterRow: false,
        hidePrint: true,
        skeletor: true
      }
    };

    this.marsQuestionsStatsService.getGroupQuestionsStats({ groupId: this.group.id }).subscribe((stats) => {
      const totalAnswers = stats.groupRightAnswers + stats.groupWrongAnswers;
      this.stats = {
        ...stats,
        percentage: totalAnswers === 0 ? 0 : stats.groupRightAnswers / totalAnswers,
        ratioAnswers: stats.totalQuestionCreated === 0 ? 0 : totalAnswers / stats.totalQuestionCreated
      };
    });

    EmitterService.get('editMarsQuestion').subscribe((question) => {
      this.editQuestion(question);
    });
    EmitterService.get('refreshQuestionsList').subscribe(() => this.dataSource.refreshData({}));
  }

  get createQuestionsDisabled() {
    return !this.group || new Date(this.group.endDate).getTime() < Date.now();
  }

  changeView(newView) {
    this.view = newView;
  }

  onQuestionsCreated(jobId) {
    const jobSubscription = this.jobsService
      .manageJob(jobId, this.jobsService.jobTypes.CREATE_QUESTIONS_BULK)
      .subscribe((jobStatus) => {
        if (jobStatus.status === 'finished' || jobStatus.status === 'fatal-error') {
          jobSubscription.unsubscribe();
          this.dataSource.refreshData({});
          this.changeView(this.viewModes.questions);
        }
      });
  }

  editQuestion(question?: any) {
    this.selectedQuestion = question;
    this.changeView(question ? this.viewModes.edit : this.viewModes.questions);
  }

  onUpdateQuestion() {
    this.selectedQuestion = null;
    this.changeView(this.viewModes.questions);
  }
}
